import React, { Component } from 'react'
import { getChamp } from '../../utils/champsFunctions'
import { getCompetitorsFromChamp, getTeams } from '../../utils/competitorsFunctions'
import { getRotationsFromChamp, getSwitchingsFromChamp } from '../../utils/confrontationsFunctions'

import './SearchCompetitor.css'

/**
 * Components
 */
import SearchCompetitorView from './SearchCompetitorView'

class SearchCompetitor extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,
            arrayOfTeams: [],

            infoModal: false,
            sumOfStudentsAddedInChamp: 0,
            loadingSum: true,
            arrayOfCompetitors: [],
            arrayOfFaixas: [{ nome: 'whiteSmoke' }, { nome: 'grey' }, { nome: 'yellow' }, { nome: 'orange' }, { nome: 'green' }, { nome: '#ffcc99' }, { nome: 'blue' }, { nome: 'purple' }, { nome: 'brown' }, { nome: 'black' }],
            arrayOfPesos: [{ nome: 'Galo' }, { nome: 'Pluma' }, { nome: 'Pena' }, { nome: 'Leve' }, { nome: 'Médio' }, { nome: 'Meio Pesado' }, { nome: 'Pesado' }, { nome: 'Super Pesado' }, { nome: 'Pesadíssimo' }],

            scoreModal: false,
            arrayOfTeamsWithScore: [],
            loadingArrayOfTeams: false,

        }
    }

    componentWillMount = async () => {
        /* Get key of champs */
        let arrayOfLocation = this.props.location.pathname.split('/')

        const champId = arrayOfLocation[3];
        await this.setState({ champId: champId });

        /* Get specific champ object */
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ
        });

        /* Get all competitors */
        let localArray = await getCompetitorsFromChamp(champId);
        this.sumOfCompetitors(localArray);

        /* Get all teams */
        this.updateListOfTeams(arrayOfLocation[3])
    }

    /**
     * Update lists
     */
    updateListOfTeams = async (key) => {
        /* Get all teams */
        let localArray = await getTeams();
        this.setState({
            arrayOfTeams: localArray
        });

        /* Get score */
        this.getTeamsScore(key);
    }

    /* Info modal stuffs */
    openInfoModal = () => {
        this.setState({ infoModal: true })
    }

    closeInfoModal = () => {
        this.setState({ infoModal: false })
    }

    sumOfCompetitors = (arrayOfCompetitors) => {
        this.setState({ loadingSum: true })
        /* Get all competitors */
        let localArray = [], localArrayOfFaixas = [], localArrayOfPesos = []

        /* Get competitors, faixas and pesos */
        arrayOfCompetitors.forEach(student => {
            localArray.push(student)

            /* Push faixa e peso to array */
            localArrayOfFaixas.push(student.faixa)
            localArrayOfPesos.push(student.peso)

        })

        /* Sum of students per faixa */
        let localArrayOfAllFaixas = this.state.arrayOfFaixas
        for (let i in localArrayOfAllFaixas) {
            localArrayOfAllFaixas[i].sum = 0
            for (let j in localArrayOfFaixas) {
                if (localArrayOfFaixas[j] === localArrayOfAllFaixas[i].nome) {
                    localArrayOfAllFaixas[i].sum += 1
                }
            }
        }

        /* Sum of students per peso */
        let localArrayOfAllPesos = this.state.arrayOfPesos
        for (let i in localArrayOfAllPesos) {
            localArrayOfAllPesos[i].sum = 0
            for (let j in localArrayOfPesos) {
                if (localArrayOfPesos[j] === localArrayOfAllPesos[i].nome) {
                    localArrayOfAllPesos[i].sum += 1
                }
            }
        }

        this.setState({
            sumOfStudentsAddedInChamp: localArray.length,
            arrayOfFaixas: localArrayOfAllFaixas,
            arrayOfPesos: localArrayOfAllPesos,
            loadingSum: false,
        })
    }

    /* Score modal stuffs */
    openScoreModal = () => {
        this.setState({ scoreModal: true })
    }

    closeScoreModal = () => {
        this.setState({ scoreModal: false })
    }

    /* Get score of all teams */
    getTeamsScore = async (key) => {
        let localArrayOfTeams = this.state.arrayOfTeams;

        /* Resetting score of all teams */
        for (let i = 0; i < localArrayOfTeams.length; i++) {
            localArrayOfTeams[i].score = 0;
        }

        /* Get score of switching from firebase */
        let switchings = await getSwitchingsFromChamp(key);
        switchings.forEach(switching => {
            if (switching.arrayOfTeams) {
                switching.arrayOfTeams.forEach(team => {

                    /* Find team in the array of all teams to score */
                    for (let j = 0; j < localArrayOfTeams.length; j++) {
                        if (localArrayOfTeams[j].nome === team.team) {

                            /* Score team */
                            localArrayOfTeams[j].score += team.score
                            break
                        }
                    }
                })
            }
        });
        await this.setState({ arrayOfTeamsWithScore: localArrayOfTeams });
        await this.sortArrayOfTeams('score');

        /* Get score of rotation from firebase */
        let rotations = await getRotationsFromChamp(key);
        rotations.forEach(rotation => {
            if (rotation.arrayOfTeams) {
                rotation.arrayOfTeams.forEach(team => {

                    /* Find team in the array of all teams to score */
                    for (let j = 0; j < localArrayOfTeams.length; j++) {
                        if (localArrayOfTeams[j].nome === team.team) {

                            /* Score team */
                            localArrayOfTeams[j].score += team.score
                            break
                        }
                    }
                })
            }
        });
        await this.setState({ arrayOfTeamsWithScore: localArrayOfTeams });
        await this.sortArrayOfTeams('score');
        this.setState({
            arrayOfTeamsWithScore: localArrayOfTeams,
            loadingArrayOfTeams: false
        });
    }

    sortArrayOfTeams = async (variable) => {
        let localArrayToSort = this.state.arrayOfTeamsWithScore;
        await this.setState({ variableToSort: variable });

        localArrayToSort.sort(this.sortStepByStep);
        this.setState({
            arrayOfTeamsWithScore: localArrayToSort
        });
    }

    sortStepByStep = (a, b) => {
        if (a[this.state.variableToSort] < b[this.state.variableToSort])
            return 1;
        if (a[this.state.variableToSort] > b[this.state.variableToSort])
            return -1;
        return 0;
    }

    render() {

        return (
            <SearchCompetitorView
                arrayOfTeams={this.state.arrayOfTeams}
                champObject={this.state.champObject}
                champId={this.state.champId}

                infoModal={this.state.infoModal}
                openInfoModal={() => this.openInfoModal()}
                closeInfoModal={() => this.closeInfoModal()}

                scoreModal={this.state.scoreModal}
                openScoreModal={() => this.openScoreModal()}
                closeScoreModal={() => this.closeScoreModal()}

                sumOfStudentsAddedInChamp={this.state.sumOfStudentsAddedInChamp}
                loadingSum={this.state.loadingSum}
                arrayOfFaixas={this.state.arrayOfFaixas}
                arrayOfPesos={this.state.arrayOfPesos}

                loadingArrayOfTeams={this.state.loadingArrayOfTeams}
                arrayOfTeamsWithScore={this.state.arrayOfTeamsWithScore}
            />
        )
    }
}

export default SearchCompetitor